import { Download, Share, SquarePlus, X } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
	Drawer,
	DrawerContent,
	DrawerDescription,
	DrawerFooter,
	DrawerHeader,
	DrawerTitle,
} from '@/components/ui/drawer'
import { usePwaInstall } from '@/hooks/use-pwa-install'
import { usePwaInstallStore } from '@/store'

// Faixa abaixo do header, só no mobile; some ao instalar ou ao dispensar
export function PwaInstallBanner() {
	const { t } = useTranslation()
	const { canInstall, install } = usePwaInstall()
	const bannerDismissed = usePwaInstallStore((s) => s.bannerDismissed)
	const dismissBanner = usePwaInstallStore((s) => s.dismissBanner)

	if (!canInstall || bannerDismissed) return null

	return (
		<div className="flex items-center gap-3 border-kaefer-light-silver border-b bg-white px-4 py-2 md:hidden">
			<img
				alt=""
				className="size-9 shrink-0 rounded-lg"
				src="/apple-touch-icon.png"
			/>
			<div className="min-w-0 flex-1">
				<p className="truncate font-semibold text-kaefer-dark-grey text-sm">
					{t('pwa.installTitle')}
				</p>
				<p className="truncate text-kaefer-medium-grey text-xs">
					{t('pwa.installDescription')}
				</p>
			</div>
			<Button className="w-auto shrink-0" onClick={install} size="sm">
				{t('pwa.install')}
			</Button>
			<Button
				aria-label={t('pwa.dismiss')}
				className="size-8 shrink-0 text-kaefer-medium-grey"
				onClick={dismissBanner}
				size="icon"
				variant="ghost"
			>
				<X className="size-4" />
			</Button>
		</div>
	)
}

// iOS não tem API de instalação: mostramos o passo a passo do "Adicionar à Tela de Início"
export function IosInstallGuide() {
	const { t } = useTranslation()
	const open = usePwaInstallStore((s) => s.iosGuideOpen)
	const setOpen = usePwaInstallStore((s) => s.setIosGuideOpen)

	const steps = [
		{ icon: Share, text: t('pwa.iosStep1') },
		{ icon: SquarePlus, text: t('pwa.iosStep2') },
		{ icon: Download, text: t('pwa.iosStep3') },
	]

	return (
		<Drawer onOpenChange={setOpen} open={open}>
			<DrawerContent>
				<DrawerHeader>
					<DrawerTitle>{t('pwa.iosTitle')}</DrawerTitle>
					<DrawerDescription>{t('pwa.iosDescription')}</DrawerDescription>
				</DrawerHeader>
				<ol className="flex flex-col gap-3 px-4">
					{steps.map(({ icon: Icon, text }, index) => (
						<li className="flex items-center gap-3" key={text}>
							<span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-kaefer-light-silver font-semibold text-kaefer-dark-grey text-sm">
								{index + 1}
							</span>
							<span className="flex-1 text-kaefer-dark-grey text-sm">
								{text}
							</span>
							<Icon className="size-5 shrink-0 text-kaefer-sapphire-blue" />
						</li>
					))}
				</ol>
				<DrawerFooter className="pb-[calc(1rem+env(safe-area-inset-bottom))]">
					<Button onClick={() => setOpen(false)}>{t('pwa.gotIt')}</Button>
				</DrawerFooter>
			</DrawerContent>
		</Drawer>
	)
}
